import { InThisLook } from "@components/InThisLook"
import { useIntl } from "@components/Intl"
import { useNotificationsUpdate } from "@components/Notifications"
import { productGroupToUid } from "@config/general"
import imgix from "@config/imgix"
import { dataLayerAddToCart } from "@lib/data-layer-events/add-to-cart"
import { getGraphQLClient } from "@lib/graphql-client"
import { useAddArticleCombinationToCart } from "@lib/hooks/use-add-article-combination-to-cart"
import { useQuery } from "@tanstack/react-query"
import { useRouter } from "next/router"
import * as qs from "query-string"
import React from "react"

const { sdk } = getGraphQLClient()
interface Props {
  ids: string[]
}

const InThisLookWrapper: React.FC<Props> = ({ ids }) => {
  const router = useRouter()
  const { mutateAsync, isLoading } = useAddArticleCombinationToCart()
  const { messages, locale } = useIntl()
  const { addNotification } = useNotificationsUpdate()
  const { data, error } = useQuery(["articleCombinations", ids], () =>
    sdk.ArticleCombinationsById({ ids })
  )

  if (!data || !data.choicesArticleCombinationsById || error) {
    return null
  }
  return (
    <>
      {data.choicesArticleCombinationsById.map((articleCombination) => {
        const image =
          articleCombination.images && articleCombination.images.length > 0
            ? imgix({
                key: articleCombination.images[0].path.replace(".png", ""),
                type: "articleCombination",
                args: { w: 200, h: 200 },
              })
            : ""

        let customizeUrl: string | null = null
        const editable =
          articleCombination.product_group === "ring" ||
          articleCombination.product_group === "earring"

        if (editable) {
          let args = {
            size: articleCombination.size,
            style: articleCombination.style,
            type: articleCombination.product_group,
            substyle: articleCombination.substyle,
            material: articleCombination.material,
          }
          if (articleCombination.articles) {
            const frame = articleCombination.articles.find(
              (a) => a.component.toLowerCase() === "frame"
            )
            const base = articleCombination.articles.find(
              (a) => a.component.toLowerCase() === "base"
            )
            const stone = articleCombination.articles.find(
              (a) => a.component.toLowerCase() === "stone"
            )
            if (frame) {
              args["frame"] = frame.id.toLowerCase()
            }
            if (base) {
              args["base"] = base.id.toLowerCase()
            }
            if (stone) {
              args["stone"] = stone.id.toLowerCase()
            }
          }

          customizeUrl = `/${locale}/configurator?${qs.stringify(args)}`
        }

        // Get urls
        const href = messages.navigation.collectionProductDetail.url
        let as = `${
          messages.navigation[
            productGroupToUid[articleCombination.product_group]
          ].url
        }/${articleCombination.slug}-${articleCombination.id}`

        return (
          <InThisLook
            key={articleCombination.id}
            image={image}
            as={as}
            href={href}
            isLoading={isLoading}
            handleConfigure={
              customizeUrl
                ? () => {
                    if (customizeUrl) {
                      router.push(customizeUrl)
                    }
                  }
                : undefined
            }
            handleAddToBag={async () => {
              await mutateAsync({
                articleId: articleCombination.id,
              })
              dataLayerAddToCart({
                id: articleCombination.id,
                name: articleCombination.name,
                price: articleCombination.price,
              })
              addNotification({
                type: "success",
                text: `${articleCombination.name} ${messages.cart.addedToCart}`,
              })
            }}
            title={articleCombination.name}
            price={articleCombination.price}
          />
        )
      })}
    </>
  )
}

export default InThisLookWrapper
